import React from "react";
import { Link } from "@mui/material";
import { RxWithTherapistsDto, RxLifespanDto } from "../../../api-client";
import { navigateWithProjection } from "../../../helpers/searchParams/navigateWithProjection";
import PatientsStore, { PATIENT_SUBTABS } from "../../../stores/Patients/patientsStore";

/**
 * Transform Rx Therapist Stats data to include clickable Rx# links
 * @param data - Array of RxTherapistsStatsDto
 * @param patientsStore - The patients store for navigation
 * @returns Transformed data with clickableRxNumber field
 */
export const transformRxTherapistsStats = (data: RxWithTherapistsDto[], patientsStore: PatientsStore): (RxWithTherapistsDto & { clickableRxNumber: JSX.Element })[] => {
    const handleClick = (rxData: RxWithTherapistsDto) => {
        const navigate = (path: string) => {
            window.open(path, '_blank');
        };

        navigateWithProjection(patientsStore, navigate as any, {
            ctor: patientsStore.constructor,
            route: '/patient',
            patch: {
                selectedPatientId: rxData.patient.id as any,
                selectedRxId: rxData.rxId,
                selectedSubTabStr: PATIENT_SUBTABS.PRESCRIPTIONS,
            },
            forceUrlBuild: true, // Force URL building since we're opening in new tab
        });
    };

    return data.map((rxData) => ({
        ...rxData,
        clickableRxNumber: (
            <Link 
                component="button"
                color="inherit" 
                onClick={() => handleClick(rxData)}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                {rxData.rxNumber}
            </Link>
        ),
    }));
};

/**
 * Transform Rx Lifespan data to include clickable Rx# links
 * @param data - Array of RxLifespanDto
 * @param patientsStore - The patients store for navigation
 * @returns Transformed data with clickableRxNumber field
 */
export const transformRxLifespanData = (data: RxLifespanDto[], patientsStore: PatientsStore): (RxLifespanDto & { clickableRxNumber: JSX.Element })[] => {
    const handleClick = (rxData: RxLifespanDto) => {
        const navigate = (path: string) => {
            window.open(path, '_blank');
        };

        navigateWithProjection(patientsStore, navigate as any, {
            ctor: patientsStore.constructor,
            route: '/patient',
            patch: {
                selectedPatientId: rxData.patient.id as any,
                selectedRxId: rxData.rxId,
                selectedSubTabStr: PATIENT_SUBTABS.PRESCRIPTIONS,
            },
            forceUrlBuild: true, // Force URL building since we're opening in new tab
        });
    };

    return data.map((rxData) => ({
        ...rxData,
        clickableRxNumber: (
            <Link 
                component="button"
                color="inherit" 
                onClick={() => handleClick(rxData)}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
                {rxData.rxNumber}
            </Link>
        ),
    }));
};
